  /**
 * 別ドメインでホストされた Webpack chunk されたjsコードを正しくLoadするためのワザ
 * https://github.com/webpack/webpack/issues/7077#issuecomment-383029585
 * Do not delete this
 */
const url = new URL(document.currentScript.src);
__webpack_public_path__ = (
  (process.env.AXE2_DEPLOYED_BASE_URL || '')
  +
  (__webpack_public_path__.startsWith('/') ? __webpack_public_path__ : '/' +  __webpack_public_path__)
)

